'use strict';

angular.module('amexReconciliationApp')
  .component('reallocateModalAccountingField', {
    templateUrl: 'scripts/views/components/reallocate-modal-accounting-field.html',
    bindings: {
      accountingFieldObject: '=',
      allocation: '<',
      comboFieldFlag: '<',
      updateAllocationsValidity: '&',
      refreshMaskValidationErrorsCount: '&',
      clearLowerComboValues: '&'
    },
    controller: function () {
      var self = this;

      self.isInSelectedComboFieldSet = function() {
        return self.accountingFieldObject.validationComboId == self.comboFieldFlag.validationComboId &&
          self.accountingFieldObject.validationComboId != 0;
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/reallocateModalAccountingField.js
// module id = 469
// module chunks = 0